import { tokens } from '@cub-com-br/theme/tokens';
import Box from '@mui/material/Box';
import { Stack } from '@mui/material';

export const Header = () => {
  return (
    <Box sx={{ backgroundColor: tokens.grey50 }}>
      <Stack direction="row" alignItems="center" justifyContent="center" px={2} py={2}>
        <Box component="img" src="/logo-in-screen.svg" alt="CUB Validador de Cobranças" sx={{ height: 35 }} />
      </Stack>
    </Box>
  );
};
